<mat-form-field>
  <mat-label>
    <ng-container *ngIf="useSalutation$ | async; else genderLabel">
      {{ ("salutation" | i18n) || "Anrede" | titlecase }}
    </ng-container>
    <ng-template #genderLabel>
      {{ ("sex" | i18n) || "Geschlecht" | titlecase }}
    </ng-template>
  </mat-label>
  <mat-select
    [ngModel]="selectedValue$ | async"
    (selectionChange)="selectionChanged($event.value)"
    name="sexSelect"
    [disabled]="(isDisabled$ | async) ?? false"
    [required]="isRequired"
    data-cy="sex-select">
    <mat-option [value]="null"> - </mat-option>
    <mat-option [value]="sexEnum.FEMALE">
      <ng-container *ngIf="useSalutation$ | async; else femaleSex">
        {{ ("mrs" | i18n) || "Frau" | titlecase }}
      </ng-container>
      <ng-template #femaleSex>
        {{ ("femaleSex" | i18n) || "female" | titlecase }}
      </ng-template>
    </mat-option>
    <mat-option [value]="sexEnum.MALE">
      <ng-container *ngIf="useSalutation$ | async; else maleSex">
        {{ ("mr" | i18n) || "Herr" | titlecase }}
      </ng-container>
      <ng-template #maleSex>
        {{ ("maleSex" | i18n) || "male" | titlecase }}
      </ng-template>
    </mat-option>
  </mat-select>
  <mat-hint
    align="end"
    *ngIf="hintContent$ | async as hintContent">
    <ng-container *ngTemplateOutlet="hintContent"></ng-container>
  </mat-hint>
</mat-form-field>
